import React, { useEffect, useState } from "react";
import support from "../images/support us.png";
import hamburger from "../images/hamburger.png";
import CloseIcon from "@mui/icons-material/Close"; // Import Close icon from Material UI
import "./Header.css";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate=useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleClick = (event) => {
    // alert("support");
    event.prevent.default();
    navigate('/')

  };

  // const isTab= window.innerWidth  >=768;
  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    // Disable scrolling when the nav is open
    if (isNavOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup function to reset scroll behavior
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isNavOpen]);

  // const imgStyle = {
  //   display: "block",
  //   width: "178px",
  //   height: "55px",
  //   borderRadius: "30px",
  //   // marginTop: "1rem",
  //   @media (max-width: 1100px) {
  //     .image {
  //       width: 150px;
  //       height: 46px;
  //     }
  //   }
  // };
  const isMobile = window.innerWidth <= 768;
  const widthLogo= window.innerWidth <= 1201;
  const isTab =window.innerWidth<=992;
  return (
    <header className="container-fluid bg-white shadow-sm">
      <div className="container-fluid  justify-content-between align-items-center " style={{ paddingTop:!isMobile? '1.5rem': '0', paddingBottom: !isMobile? '1rem': '0'}}>
     <div className="container-fluid d-flex justify-content-between align-items-center ">
       <div className='logoContainer' style={{width:widthLogo? '50%': "33%", marginLeft: isTab? '-1.5rem': '0' , marginTop: isMobile? '1.3rem':'0rem'}}>
        <img 
        src="https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/6704e39396bdc0b07ae80085_Group%20427318519.svg"
         alt="Sood Charity Foundation" className="logo"  
         onClick={()=> window.location.href='https://www.soodcharityfoundation.org'}
         srcset="https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/671a4706e74ef81f009e117e_sood%20nav%20jpg-p-500.jpg 500w, https://cdn.prod.website-files.com/66e57a87d269af52d9f22ec3/671a4706e74ef81f009e117e_sood%20nav%20jpg.jpg 682w"   
         style={{ maxWidth:'130%', width:isMobile?'130%':'100%' , marginLeft: isMobile? '0': '1.5rem', }} 
         />
    </div>

 <img
          id="type"
          src={support}
          alt="Support us"
          className="imgStyle d-none d-lg-block ml-[90%]"
          onClick={handleClick}
        />
        </div>
        <button
          className="navbar-toggler d-lg-none"
          type="button"
          onClick={toggleNav}
        >
          {isNavOpen ? (
            <CloseIcon fontSize="medium" />
          ) : (
            <img className="hamburger" src={hamburger} alt="menu" 
            style={{
              marginTop: isTab? '0.5rem':'0.5rem',
              width: isTab? "16px" :"14px",height: isTab? "16px" :"14px",
            }} />
          )}
        </button>

        {/* Full-screen mobile nav */}
        <nav className={`d-lg-none mobile-nav ${isNavOpen ? "open" : ""} overflow-auto`}>
          <a href="https://www.soodcharityfoundation.org/about-us" className="nav-link">
            About Us
          </a>
          <a href="https://www.soodcharityfoundation.org/our-team" className="nav-link">
            Our Team
          </a>
          <a href="https://www.soodcharityfoundation.org/our-campaigns" className="nav-link">
            Our Campaigns
          </a>
          <a href="https://www.soodcharityfoundation.org/our-projects" className="nav-link">
            Our Projects
          </a>
          <a href="https://www.soodcharityfoundation.org/ssc-club" className="nav-link">
            SSC Club
          </a>
          <a href="https://www.soodcharityfoundation.org/our-partner" className="nav-link">
            Our Partners
          </a>
          <a href="https://www.soodcharityfoundation.org/contact-us" className="nav-link">
            Contact Us
          </a>

          <img
            id="type"
            src={support}
            alt="Support us"
            className="imgStyle"
            onClick={handleClick}
          />
        </nav>

        {/* Desktop nav */}
        <div className="navbar mt-2 mb-2  " style={{width:'100%'}}>
        <nav
          className="link  d-none d-lg-flex "
          style={{ color: "#888888", fontWeight: "600" , fontSize:'1.2vw',  justifyContent: 'space-between ', width:'100%'}}
        >
          <a href="https://www.soodcharityfoundation.org/about-us" className="nav-link ">
            About Us
          </a>
          <a href="https://www.soodcharityfoundation.org/our-team" className="nav-link ">
            Our Team
          </a>
          <a href="https://www.soodcharityfoundation.org/our-campaigns" className="nav-link ">
            Our Campaigns
          </a>
          <a href="https://www.soodcharityfoundation.org/our-projects" className="nav-link ">
            Our Projects
          </a>
          <a href="https://www.soodcharityfoundation.org/ssc-club" className="nav-link " >
            SSC Club
          </a>
          <a href="https://www.soodcharityfoundation.org/our-partner" className="nav-link">
            Our Partners
          </a>
          <a href="https://www.soodcharityfoundation.org/contact-us" className="nav-link ">
            Contact Us
          </a>
        </nav>
        </div>
       
      </div>
    </header>
  );
};

export default Header;
